export default function findBySlug(items, slug) {
  if (!slug) {
    return undefined;
  }
  return items?.find((item) => item.slug === slug);
}
